module.exports = __webpack_public_path__ + "7a345617f870370c6d463012f7a5323c.pdf";